import React from 'react';
import ErrorMessage from '@/components/errors/ErrorMessage';

const UnmanagedDataMessage = ({ reasons }) => (
  <ErrorMessage
    className="modal-message aridhia-unmanaged-data"
    error={{
      title: 'dataset.data.unmanaged.data.title',
      message: 'dataset.data.unmanaged.data.message',
      details: reasons,
      translation: { on: true },
      warning: true,
    }}
  />
);

export default UnmanagedDataMessage;
